
export const classes = {
    usingTouch: "using-touch",
    usingMouse: "using-mouse",
    usingTab: "using-tab",
};

let mouseMoves = 0;
// eslint-disable-next-line prefer-const
let unbindFunctions: () => void;

const touchFired = (): void => {
    document.documentElement.classList.add(classes.usingTouch);
    document.documentElement.classList.remove(classes.usingMouse);
    unbindFunctions();
};

const mouseMoved = (): void => {
    mouseMoves += 1;

    if (mouseMoves >= 5) {
        document.documentElement.classList.add(classes.usingMouse);
        document.documentElement.classList.remove(classes.usingTouch);
        unbindFunctions();
    }
};

unbindFunctions = (): void => {
    document.removeEventListener("touchstart", touchFired);
    document.removeEventListener("mousemove", mouseMoved);
};

export const detectInputMethod = (): void => {
    if (window.matchMedia('(hover: none)').matches) {
        document.documentElement.classList.add(classes.usingTouch);
    } else {
        document.documentElement.classList.add(classes.usingMouse);
    }
    document.addEventListener("touchstart", touchFired);
    document.addEventListener("mousemove", mouseMoved);
};
